import { useEffect, useState } from "react";
import DropDown from "@weave-design/dropdown";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";

export type EnumPropertyOption = [number, string];

type Props = {
    items: EnumPropertyOption[];
    value: number;
    title: string;
    onChange: (newValue: number) => void;
};

export const EnumPropertySelector = ({ items, value, title, onChange }: Props) => {
    const [options, setOptions] = useState<string[]>([]);
    const [selectedOption, setSelectedOption] = useState("");

    useEffect(() => {
        const opts = enumOptionsToAray(items);
        setOptions(opts);
        setSelectedOption(opts[value]);
    }, [value, items]);

    const onSelect = (value: string) => {
        setSelectedOption(value);
        onChange(options.indexOf(value));
    };

    return (
        <PropertyEditor title={title}>
            <DropDown options={options} value={selectedOption} onChange={(value: string) => onSelect(value)} />
        </PropertyEditor>
    );
};

const enumOptionsToAray = (options: EnumPropertyOption[]) => {
    const items: string[] = [];

    for (const option of options) {
        items[option[0]] = option[1];
    }

    return items;
};
